export const LESSON_HOMEWORK_START_TIME = 'lesson_homework_start_time';
export const LESSON_HOMEWORK_END_TIME = 'lesson_homework_end_time';
